import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    let type = this.element.dataset.flashType;
    let message = this.element.dataset.flashMessage;

    toastr[type](message, '', toastOptions)
    document.querySelector('#errors-container').innerHTML = "";
  }
}